import React, { useRef, useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { fetchdata, viewdata, adddata, UploadImageData, doceditdata, doceditdatanoimage, DeleteData } from './../reduxactions/fundmanagersactions/DocumentActions';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { Toast } from 'primereact/toast';
import { GFNButton } from '../ui';
import { Panel } from 'primereact/panel';

export const FundDocuments = () => {

  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('')
  const data = useSelector((state: RootState) => state.fmdocm.data);
  const DataView = useSelector((state: RootState) => state.fmdocm.DataView);
  const Deletedatas = useSelector((state: RootState) => state.fmdocm.Deletedata);
  const adddatacheck = useSelector((state: RootState) => state.fmdocm.adddata);



  const dispatch = useDispatch();

  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  // To get data
  useEffectOnce(() => {
    fetchDataAsync();
  }, [dispatch]);
  // View data
  //To assign data 
  const [acceptfield, setfield] = useState(false);
  const cancelfield = () => {
    setfield(false);
  }
  //To assign data 

  const viewDoc = (rowData: any) => {

    assignData.current = { DocID: rowData.DocID }
    setfield(true);
    fetchDataAsyncdialog();
  };
  const assignData = useRef({ DocID: '' })
  const fetchDataAsyncdialog = async () => {
    try {
      const { DocID } = assignData.current;
      console.log("DocID", DocID)
      await dispatch(viewdata(DocID) as any);
    } catch (error) {
      console.error('Error deleting data:', error);
    }
  };
  // Add data


  //To add property holder
  const [Adddocument, setAdddocument] = useState(false);
  const [document, setDocument] = useState<string>('');
  // const [date, setDate] = useState<Date | null>(new Date());
  const [file, setFile] = useState<string>('');
  const [fileName, setFileName] = useState('');
  const [date, setDate] = useState<Date | null>(null);


  //To add Adddocument dispatching data to ts
  const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
    const files = event.files;
    if (files.length > 0) {
      const file = files[0];
      console.log("file:", file)
      console.log("called image function:", file)
      try {
        await dispatch(UploadImageData(file, uid) as any);
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }

  };
  const adddatafile = useSelector((state: RootState) => state.fmdocm.imgdata);
  console.log("adddatafile", adddatafile)

  const adduploads = async () => {
    const filename = adddatafile.filename;
    await dispatch(adddata(document, date, filename, uid) as any);
    setAdddocument(false);
    fetchDataAsync();
    toast2.current.show({ severity: 'success', summary: 'Document Added Successfully', detail: adddatacheck, life: 3000 })
  };

  // Edit data
  const [Editdoc, SetEdit] = useState(false);

  const [editData, setEditData] = useState({
    CreteDate: '',
    doc_name: '',
    expiry_date: '',
    id: '',
    adddatafile: '',
    UserID: ''
  });

  const EditAdminManager = async () => {
    // if (adddatafile && adddatafile.length >0) {
    const filename = adddatafile.filename;
    if (adddatafile && adddatafile.filename) {

      console.log("Add file only called")
      const { doc_name, expiry_date, adddatafile, id, UserID } = editData;
      await dispatch(doceditdata(doc_name, expiry_date, filename, parseInt(id, 10), UserID) as any);
    } else {
      console.log("Without file only called")


      const { doc_name, expiry_date, id, UserID } = editData;
      await dispatch(doceditdatanoimage(doc_name, expiry_date, parseInt(id, 10), UserID) as any);
    }
    fetchDataAsync();
    SetEdit(false);
    toast1.current.show({ severity: 'success', summary: 'Document Updated Successfully', detail: editdatasmsg, life: 3000 })

  }
  const editdatasmsg = useSelector((state: RootState) => state.fmdocm.editdat);
  const editupload = (rowData: any) => {
    setEditData({
      CreteDate: rowData.CreteDate,
      doc_name: rowData.doc_name,
      expiry_date: rowData.expiry_date,
      id: rowData.DocID,
      adddatafile: adddatafile,
      UserID: rowData.UserID

    });
    SetEdit(true);
  }
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);


  //To delete data 
  const [delData, setDeleteData] = useState({
    DocID: '',
  });
  //data from table 
  const Delete = (rowData: any) => {
    setDeleteData({
      DocID: rowData.DocID,
    });
    setDeleteConfirmation(true);
  };
  //To dispatch data to delete in fieldofficeraction.ts
  const confirmDelete = async () => {
    const { DocID } = delData;
    try {
      await dispatch(DeleteData(DocID) as any);
      setDeleteConfirmation(false);
    } catch (error) {
      console.error('Error deleting data:', error);
    }
    const fetchDataAsync = async () => {
      try {
        await dispatch(fetchdata(uid) as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    toast.current.show({ severity: 'success', summary: 'Success', detail: Deletedatas, life: 3000 })

    fetchDataAsync();

  };
  //To close dialog box
  const cancelDelete = () => {
    setDeleteConfirmation(false);
  };

  const toast = useRef(Deletedatas);
  const toast1 = useRef(editdatasmsg);
  const toast2 = useRef(adddatacheck);
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/fmdocuments.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    // get data
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">Documents</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
            <Panel>
              <div className="grid">
                <div className="col-12">
                  <div className="card card-primary">
                    <div className="card flex flex-wrap justify-content-end">
                      {/* <Button label="Add Documents" severity="info" data-testid="add-document-btn" onClick={() => setAdddocument(true)} /> */}
                      <GFNButton label="Add Documents" buttonType="primary" data-testid="add-document-btn" rounded onClick={() => setAdddocument(true)} />
                    </div>
                    <div className="card flex flex-wrap justify-content-end my-2">
                      <span className="p-input-icon-left">
                        <i className="pi pi-search ml-2" />

                        <InputText
                          className="app-search-input"
                          value={globalFilter}
                          onChange={(e) => setGlobalFilter(e.target.value)}
                          placeholder="Global Search"
                        />
                      </span>
                    </div>
                    <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                      <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                      <Column field="CreteDate" sortable header="Uploaded Date"></Column>
                      <Column field="expiry_date" sortable header="Expiry Date"></Column>
                      <Column field="doc_name" sortable header="Title "></Column>

                      <Column header="Operation" body={(rowData, { rowIndex }) => (
                        <>
                          {/* <Button icon="pi pi-eye" data-testid={`view-btn-${rowIndex}`} tooltip="View" className='mr-4' onClick={() => viewDoc(rowData)} aria-label="View" style={{ backgroundColor: 'white', color: 'blue', borderRadius: '30px', width: '2rem', height: '2rem' }} />
                          <Button className='mr-4' data-testid={`edit-btn-${rowIndex}`} tooltip="Edit" severity="info" rounded outlined icon="pi pi-pencil" onClick={() => editupload(rowData)} style={{ color: 'mediumseagreen', width: '2rem', height: '2rem' }} />
                          <Button icon="pi pi-trash" data-testid={`delete-btn-${rowIndex}`} tooltip="Delete" onClick={() => Delete(rowData)} rounded outlined className="p-button-danger mr-1" style={{ width: '2rem', height: '2rem' }} /> */}
                          <GFNButton icon="pi pi-eye" data-testid={`view-btn-${rowIndex}`} tooltip="View" className='mr-3' onClick={() => viewDoc(rowData)} aria-label="View" buttonType='primary'/>
                          <GFNButton className='mr-3' data-testid={`edit-btn-${rowIndex}`} tooltip="Edit" buttonType="success" rounded outlined icon="pi pi-pencil" onClick={() => editupload(rowData)}  />
                          <GFNButton icon="pi pi-trash" data-testid={`delete-btn-${rowIndex}`} tooltip="Delete" onClick={() => Delete(rowData)} rounded outlined buttonType="danger" className="mr-1"  />
                        </>

                      )} />
                    </DataTable>
                  </div>
                </div>
              </div>

            </Panel>
          </div>
          <Dialog header="View" style={{ width: '50vw' }} visible={acceptfield} onHide={cancelfield}>
            <div className="modal-body">
              {DataView.map((response: any, index: number) =>
                <div key={index}>
                  {response.filetype === 'photo' && <img src={response.displayfile} alt="Doc" width="100%" height="auto" />}
                  {response.filetype !== 'photo' &&
                    <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                  }
                  {response.filetype === 'pdf' && (
                    <a href={response.displayfile} target="_blank" rel="noopener noreferrer">
                      Open PDF in New Tab
                    </a>
                  )}
                </div>
              )}
            </div>
            <Button label="Close" className="ml-2" data-testid="view-close-btn" severity="secondary" onClick={cancelfield} />
          </Dialog>
          <Dialog header="Upload Document" data-testid="add-dialog" visible={Adddocument} style={{ width: '30vw', height: '40' }} onHide={() => setAdddocument(false)} >
            <div className='row'>
              <div className='row'>
                <div className="grid pt-3">
                  <div className="col-3">
                    <label htmlFor="name"   >Document Title:</label>
                  </div>
                  <div className="col md-3" >
                    <InputText id="name" data-testid="add-document-input" style={{ width: '15vw' }} name="document" placeholder='Document-title' onChange={(e) => setDocument(e.target.value)} />
                  </div>
                  <div className="col-2" ></div>
                </div>
              </div>
              <div className='row'>
                <div className="grid pt-3">
                  <div className="col-3">
                    <label htmlFor="year" >Expiry Date:</label>
                  </div>
                  <div className="col md-3" >

                    <Calendar
                      id="expdate"
                      data-testid="add-edate-date"
                      style={{ width: '15vw' }}
                      name="date"
                      placeholder="dd-mm-yyyy"
                      value={date}
                      onChange={(e) => setDate(e.value as Date)}
                      dateFormat="dd-mm-yy"
                    />
                  </div>
                </div>
              </div>
              {/* <div className='row'>
                                    <div className="grid pt-3">
                                        <div className="col-3">
                                            <label htmlFor="file" >Select File:</label>
                                        </div>
                                        <div className="col-3" >
                                                <FileUpload mode="basic" id="fileToUpload" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                                        </div>
                                        </div>
                                    </div> */}
              <div className='row'>
                <div className="grid pt-3">

                  <div className="col-3">
                    <label htmlFor="file">Select File:</label>
                  </div>

                  <div className="col-3">
                    <FileUpload
                      mode="basic"
                      id="fileToUpload"
                      name="fileToUpload"
                      data-testid="add-file-upload"
                      customUpload
                      accept="image/*"
                      maxFileSize={1000000}
                      uploadHandler={UploadManagerImage}
                      auto
                      onSelect={(e) => {
                        setFileName(e.files[0].name);
                      }}
                    />

                    {fileName && (
                      <div className="mt-2">
                        {fileName}
                      </div>
                    )}
                  </div>

                </div>
              </div>
            </div>
            <br></br>
            <Button label="Close" className="ml-2" data-testid="add-close-btn" severity="secondary" onClick={cancelfield} />
            <Button label="ADD" severity="info" data-testid="add-add-btn" onClick={adduploads} style={{ float: 'right', marginRight: "30px" }} />
          </Dialog>


          <Dialog header="Upload Document" data-testid="add-dialog" visible={Editdoc} style={{ width: '30vw', height: '40' }} onHide={() => SetEdit(false)} >
            <div className='row'>
              <div className='row'>
                <div className="grid pt-3">
                  <div className="col-3">
                    <label htmlFor="name"   >Document Title:</label>
                  </div>
                  <div className="col md-3" >
                    <InputText id="name" data-testid="edit-document-input" style={{ width: '15vw' }} name="Doctitle" onChange={(e) => setEditData({ ...editData, doc_name: e.target.value })} value={editData.doc_name} />
                  </div>
                  <div className="col-2" ></div>
                </div>
              </div>
              <div className='row'>
                <div className="grid pt-3">
                  <div className="col-3">
                    <label htmlFor="year" >Expiry Date:</label>
                  </div>
                  <div className="col md-3" >
                    {/* <Calendar id="expdate" value={editData.expiry_date} style={{ width: '15vw' }} name="date" placeholder='dd-mm-yyyy' onChange={(e) => setEditData({ ...editData, expiry_date: e.value as Date | null })}  /> */}
                    <InputText id="expdate" data-testid="edit-edate-date" type="date" style={{ width: '15vw' }} name="date" onChange={(e) => setEditData({ ...editData, expiry_date: e.target.value })} value={editData.expiry_date} />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className="grid pt-3">
                  <div className="col-3">
                    <label htmlFor="file" >Select File:</label>
                  </div>
                  <div className="col-3" >

                    <FileUpload mode="basic" data-testid="edit-file-upload" id="fileToUpload" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                  </div>
                </div>
              </div>
            </div>
            <br></br>
            <Button label="Close" className="ml-2" data-testid="edit-close-btn" severity="secondary" onClick={cancelfield} />
            <Button label="Update" data-testid="edit-update-btn" className="p-button-success p-button-outlined" onClick={EditAdminManager} style={{ float: 'right', backgroundColor: 'blueviolet', color: 'white' }} />
          </Dialog>


          <Dialog header="Confirm Delete" data-testid="delete-dialog" style={{ width: '30vw' }} visible={deleteConfirmation} onHide={cancelDelete}>
            <div>Are you sure you want to delete?</div>
            <Button label="Yes" icon="pi pi-check" data-testid="delete-yes-btn" className='mr-3 p-button-raised' onClick={confirmDelete} />
            <Button label="No" icon="pi pi-times" data-testid="delete-no-btn" onClick={cancelDelete} className="mr-3 p-button-secondary" />
          </Dialog>


          <Toast ref={toast} >
            <Message severity="success" content={Deletedatas}></Message>
          </Toast>
          <Toast ref={toast1} >
            <Message severity="success" content={editdatasmsg}></Message>
          </Toast>
          <Toast ref={toast2} >
            <Message severity="success" content={adddatacheck}></Message>
          </Toast>


        </div>
      </div>
    </div>

  )

}

export default FundDocuments